import dayjs from "dayjs";

export function humanizePast(targetDate: string): string {
	const now = dayjs();
	const past = dayjs(targetDate);
	const diffMs = now.diff(past);

	if (diffMs < 0) return "in the future";
	if (diffMs < 60_000) return "just now";

	const d = dayjs.duration(diffMs);

	const minutes = Math.floor(d.asMinutes());
	const hours = Math.floor(d.asHours());
	const days = Math.floor(d.asDays());
	const weeks = Math.floor(days / 7);
	const months = Math.floor(days / 30);
	const years = Math.floor(days / 365);

	if (minutes < 60) {
		return `${minutes}m ago`;
	} else if (hours < 24) {
		return `${hours}h ago`;
	} else if (days < 7) {
		return `${days}d ago`;
	} else if (weeks < 5) {
		return `${weeks}w ago`;
	} else if (months < 12) {
		return `${months}mo ago`;
	} else {
		return `${years}y ago`;
	}
}

export const tabOptions = [
	{
		label: "12 Months",
		value: "12m",
	},
	{
		label: "24 Months",
		value: "24m",
	},
];

export const mostUsedOptions = [
	{
		label: "Tasks",
		value: "task",
	},
	{
		label: "Labels",
		value: "label",
	},
];

export const mostUsedTableHeaders = [
	{
		title: "Name",
		align: "start",
		key: "name",
	},
	{
		title: "Times used",
		align: "end",
		key: "count",
	},
];
